/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import MaterialTable, { MTableToolbar } from "material-table";
import table_icons from "../../tableIcons";
import { Typography, Divider, IconButton, Tooltip } from "@material-ui/core";
import {
  Add,
  Refresh,
  SubdirectoryArrowRight,
  Edit,
  Delete,
} from "@material-ui/icons";

import Actions from "../../../fluid/Actions/ActionFactory";

import CreateEvent from "./CreateEvent";

import { DeleteConfirmationDialog } from "./../../Utilities/DeleteConfirmationDialog";
import ErrorMessageAlert from "./../../Utilities/ErrorMessageAlert";

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    // primary: {
    // main: "#FF6600",
    // contrastText: "#FFFFFFFF"
    // },
    secondary: {
      main: "#dc004e",
    },
  },
});

const styles = (theme) => ({});

class EventList extends Component {
  state = {
    add_event: false,
    event_state: null,
    event_obj: null,
    data: [],
    data_loading: false,
    data_err: false,
    deletingItem: {},
    errorOpen: false,
    errorInfo: {},
    confirmDeleteDialogOpen: false,
  };

  componentWillMount() {
    this.getEvents();
  }

  getEvents = () => {
    this.setState(
      {
        ...this.state,
        data_loading: true,
      },
      () => {
        Actions("http_request", {
          url: "/sainapse/event_group/" + this.props.event_group + "/event",
          method: "get",
          data: {},
        })
          .then((res) => {
            console.log("new events", res.data.result);
            this.setState({
              ...this.state,
              data: res.data.result || [],
              data_err: false,
              data_loading: false,
            });
          })
          .catch((err) => {
            console.log("error", this.state);
            this.setState({
              ...this.state,
              data: [],
              data_err: true,
              data_loading: false,
            });
          });
      }
    );
  };

  closeDialog = () => {
    this.setState(
      {
        ...this.state,
        add_event: false,
        event_state: null,
        event_obj: null,
      },
      () => this.getEvents()
    );
  };

  openEventDialog = (event_state, event_obj) => {
    this.setState({
      ...this.state,
      add_event: true,
      event_state: event_state,
      event_obj: event_obj,
    });
  };

  renderEventDialog = () => {
    if (this.state.add_event) {
      return (
        <CreateEvent
          open={this.state.add_event}
          close={this.closeDialog}
          event_state={this.state.event_state}
          event_obj={this.state.event_obj}
          event_group={this.props.event_group}
          zIndex="10"
        />
      );
    }
  };

  cancelDelete = () => {
    console.log("cancelling delelte");
    this.setState({ deletingItem: {}, confirmDeleteDialogOpen: false });
  };

  confirmDelete = () => {
    this.setState({ confirmDeleteDialogOpen: false });

    Actions("http_request", {
      url: "/sainapse/event/" + this.state.deletingItem.name,
      method: "delete",
      data: {},
    })
      .then((res) => {
        this.setState({ deletingItem: {} });
        this.getEvents();
      })
      .catch((err) =>
        this.setState({
          deletingItem: {},
          errorOpen: true,
          errorInfo: err,
        })
      );
  };

  //delete
  deleteEvent = (rowData) => {
    console.log("delete event", rowData);
    this.setState(
      { deletingItem: rowData, confirmDeleteDialogOpen: true },
      () => {
        console.log(this.state);
      }
    );
  };

  //error
  handleErrorClose = () => {
    console.log("handle close");
    this.setState({ errorOpen: false, errorInfo: {} });
  };

  renderEventActions = (row_data) => {
    if (
      row_data.id !== this.state.deletingItem.id ||
      this.state.confirmDeleteDialogOpen
    ) {
      return (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Tooltip title="Edit">
            <IconButton
              size="small"
              onClick={() => this.openEventDialog("modify", row_data)}
            >
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              size="small"
              color="secondary"
              onClick={() => this.deleteEvent(row_data)}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      );
    } else {
      return <Typography variant="overline">Deleting...</Typography>;
    }
  };

  render() {
    console.log(
      "rendering event list",
      this.state.data,
      this.props.event_group
    );
    return (
      <ThemeProvider theme={blue_theme}>
        <MaterialTable
          style={{ margin: "10px 20px" }}
          title={
            <Fragment>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                }}
              >
                <SubdirectoryArrowRight style={{ color: "rgba(0,0,0,0.5)" }} />
                <Typography
                  style={{ fontWeight: 300, marginLeft: "5px" }}
                  display="inline"
                  variant="subtitle2"
                >
                  {"Events Registered under"}
                </Typography>
                <Typography
                  style={{ fontWeight: 500, marginLeft: "5px" }}
                  display="inline"
                  variant="subtitle2"
                >
                  <em>{this.props.event_group}</em>
                </Typography>
              </div>
            </Fragment>
          }
          icons={table_icons}
          columns={[
            {
              title: "Event Name",
              field: "name",
            },
            {
              title: "Details",
              field: "title",
              render: (rowData) => (
                <div style={{ width: "40vw" }}>
                  <Typography variant="subtitle2">{rowData.title}</Typography>
                  <Typography variant="body2" color="textSecondary">
                    {rowData.description}
                  </Typography>
                </div>
              ),
            },
            {
              title: "Created Date",
              field: "created_date",
              type: "datetime",
            },
            {
              title: "Updated Date",
              field: "updated_date",
              type: "datetime",
              defaultSort: "desc",
            },
            {
              title: "Actions",
              field: "",
              render: (rowData) => this.renderEventActions(rowData),
            },
          ]}
          data={this.state.data || []}
          isLoading={this.state.data_loading}
          options={{
            search: true,
            cellStyle: {
              height: "20px",
              paddingLeft: "10px",
            },
            toolbarButtonAlignment: "right",
            paging: false,
            headerStyle: {
              height: "7vh",
              padding: 0,
              margin: 0,
              paddingLeft: "10px",
              backgroundColor: "#F0F0F0",
              lineHeight: "1.25",
            },
            maxBodyHeight: "50vh",
            detailPanelType: "single",
            draggable: false,
          }}
          components={{
            Toolbar: (props) => (
              <Fragment>
                <MTableToolbar {...props} />
                <Divider />
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row-reverse",
                    height: "5vh",
                    alignContent: "flex-end",
                  }}
                >
                  <Tooltip title="Add Event">
                    <IconButton
                      color="primary"
                      onClick={() => this.openEventDialog("create", {})}
                    >
                      <Add />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Refresh">
                    <IconButton color="primary" onClick={this.getEvents}>
                      <Refresh />
                    </IconButton>
                  </Tooltip>
                </div>
              </Fragment>
            ),
          }}
        />
        {this.renderEventDialog()}
        {this.state.errorOpen ? (
          <ErrorMessageAlert
            open={this.state.errorOpen}
            handleClose={this.handleErrorClose}
            errorInfo={this.state.errorInfo}
          ></ErrorMessageAlert>
        ) : null}
        <DeleteConfirmationDialog
          style={{ zIndex: 10000 }}
          open={this.state.confirmDeleteDialogOpen}
          name={this.state.deletingItem.name}
          type={"Event"}
          confirmDeleteHandler={this.confirmDelete}
          cancelDeleteHandler={this.cancelDelete}
        ></DeleteConfirmationDialog>
      </ThemeProvider>
    );
  }
}

export default withStyles(styles)(EventList);
